// extracted by mini-css-extract-plugin
export var attachment = "_rk-a";
export var emailContainer = "_rk-4";
export var emailContentPaddedContainer = "_rk-b";
export var emailHeader = "_rk-6";
export var emailIframe = "_rk-3";
export var emailInfoIcon = "_rk-9";
export var emailShortenedSummary = "_rk-e";
export var infoDropdown = "_rk-0";
export var infoRowBoundedContent = "_rk-d";
export var internal = "_rk-5";
export var merchant = "_rk-8";
export var messageInputContainer = "_rk-h";
export var normal = "_rk-7";
export var replyCard = "_rk-f";
export var subtleButton = "_rk-1";
export var subtleButtonIconContainer = "_rk-2";
export var toggleViewRepliesButton = "_rk-c";
export var wrappingText = "_rk-g";